angular.module('leanlaw').controller('BillingCtrl', ['$scope', '$state', '$stateParams', 'userService', 'matterFilterService', 'accountingService', 'invoiceFilterService', 'printPreview', 'alerts', function ($scope, $state, $stateParams, userService, matterFilterService, accountingService, invoiceFilterService, printPreview, alerts) {
  $scope.print = printPreview;
  $scope.state = invoiceFilterService.state;
  $scope.status = {
    loading: true
  };
  $scope.currentState = $state.current;
  // angular-ui-router 0.4's ui-sref-active takes one state per class, so a sidebar row
  // that stands for several pages asks here instead.
  $scope.isCurrentIn = (...stateNames) => stateNames.some(name => $state.includes(name));
  activate();
  //////////////////
  function activate() {
    // reset client matter selection
    if ($stateParams.reload) {
      $scope.state.cm = {};
      matterFilterService.state.matter = null;
      matterFilterService.state.client = null;
    }
    userService.me().then(me => {
      $scope.me = me;
      $scope.workflow = me.company.settings.workflow || {};
    });
    $scope.$on('$stateChangeSuccess', () => {
      invoiceFilterService.stateChanged();
      updateShowSecondarySplitMatter();
    });
    $scope.state = invoiceFilterService.state;
    $scope.$watch('state.cm', (value, previous) => {
      if (value?.client?.id === previous?.client?.id && value?.matter?.id === previous?.matter?.id) {
        return;
      }
      invoiceFilterService.filterChanged();
    }, true);
    $scope.state.filter.scope = $stateParams.scope;
    $scope.state.filter.scopeAccount = $stateParams.scopeAccount;

    // Build query-filter object for ll-client-matter-search directive.
    // Placed on `state` (invoiceFilterService.state) rather than $scope
    // because child states use named views whose scopes don't inherit $scope props.
    $scope.state.cmQuery = {
      originating: false,
      involved: false,
      reviewer: false,
      primary: false,
      scopeAccount: null,
      archived: false,
      showSecondarySplitMatter: false
    };
    function updateCmQuery() {
      const mfs = matterFilterService.state;
      const hasAccount = !!mfs.scopeAccount;
      $scope.state.cmQuery.primary = hasAccount && !!mfs.primary;
      $scope.state.cmQuery.originating = hasAccount && !!mfs.originating;
      $scope.state.cmQuery.reviewer = hasAccount && !!mfs.reviewer;
      // 'involved' = account selected but no specific role checkbox
      $scope.state.cmQuery.involved = hasAccount && !mfs.primary && !mfs.originating && !mfs.reviewer;
      $scope.state.cmQuery.scopeAccount = mfs.scopeAccount ? mfs.scopeAccount.id || mfs.scopeAccount : null;
    }
    updateCmQuery();

    // Match prior ll-client-matter-picker behavior: only show secondary
    // split matters on payment summary, trust summary, and QuickBooks tabs.
    function updateShowSecondarySplitMatter() {
      const name = $state.current.name;
      const allowed = name === 'billing.payment.summary' || name.startsWith('billing.trust.summary') || name === 'billing.review.quickbooks';
      $scope.state.cmQuery.showSecondarySplitMatter = allowed;

      // Clear a selected split matter when navigating to a page that hides them.
      if (!allowed && $scope.state.cm.matter?.primaryMatterId) {
        $scope.state.cm.matter = null;
      }
    }
    updateShowSecondarySplitMatter();

    // Watch matterFilterService (the actual source of truth for "Matters Involving")
    // rather than invoiceFilterService.state.filter, which was never connected.
    $scope.$watch(() => matterFilterService.state.scope, updateCmQuery);
    $scope.$watch(() => {
      const acct = matterFilterService.state.scopeAccount;
      return acct ? acct.id || acct : null;
    }, updateCmQuery);
    accountingService.verify(true).then(status => {
      $scope.status = status;
    }).catch(status => {
      $scope.status = status;
    });
    $scope.goToAdvancedReport = async function () {
      await userService.reload();
      $scope.me = await userService.me();
      $state.go('^', {}, {
        reload: true
      });
      if ($scope.me.role !== 'principal' && $scope.me.role !== 'operator') {
        alerts.error("You do not have access to this feature. Please contact your account administrator.");
        return;
      }
      if ($scope.me.features.reportsAdvanced) {
        // The Invoice Insights report is a tagged Metabase dashboard, loaded
        // by InvoiceInsights.vue — no dashboard lookup needed here.
        $state.go('billing.invoiceInsights');
      } else {
        $state.go('billing.upgradePlan');
      }
    };
  }
}]);